import {ICsvInterceptor} from '../../core/csv/csv-interceptor';

export class InventoryOrderCsvInterceptor implements ICsvInterceptor {
  transform(item: any) {
    let copy = Object.assign({}, item);
    copy.expedited_order = item.expedited_order ? 'Yes' : (item.expedited_order === false ? 'No' : '');
    return copy;
  }
}
